<template>
  <q-banner
    v-if="updateStore.state.updateAvailable"
    class="bg-warning q-pa-sm text-black"
    inline>
    <div class="row items-center q-col-gutter-sm">
      <div class="col-auto">
        <q-icon
          :name="symRoundedWarning"
          size="xl" />
      </div>
      <div class="col row justify-between items-center">
        <div class="column">
          <div class="text-h6">{{ $t('crudmanager.updateManager.updateAvailable') }}</div>
          <div class="text-body1 q-py-md">{{ $t('crudmanager.updateManager.restartRequired') }}</div>
        </div>
        <div>
          <q-btn
            color="black"
            class=""
            :label="$t('crudmanager.updateManager.updateNow')"
            @click="updateStore.installUpdate" />
        </div>
      </div>
    </div>
  </q-banner>
</template>
<script setup lang="ts">
import { symRoundedWarning } from '@quasar/extras/material-symbols-rounded'
import { useUpdateStore } from 'src/CrudManager/Core/stores/useUpdateStore'

const updateStore = useUpdateStore()
</script>
